const encode = (numbers: string) => {
  return btoa(encodeURIComponent(numbers));
};

const decode = (id: string) => {
  return atob(id);
};

export { decode, encode };
